import { gql } from "@apollo/client";
import { useMutation, useQuery } from "@apollo/client/react";
import { notifications } from "@mantine/notifications";
import { useParams } from "react-router-dom";
import { CreationForm } from "../../../components/form/CreationForm";
import { constructCustomFieldsForm } from "../../../components/form/CustomFieldsForm";
import { PageHeader } from "../../../components/PageHeader";
import { FormSkeleton } from "../../../components/SkeletonLoader";

const EVENT_CUSTOM_FIELDS_QUERY = gql`
  query eventCustomFields($id: ID!) {
    event(id: $id) {
      configuration {
        customFields {
          name
          type
          property
          order
          unique
          required
          public
          editability
          visibility
        }
      }
    }
  }
`;

const UPDATE_EVENT_CUSTOM_FIELDS = gql`
  mutation eventUpdateCustomFields(
    $id: ID!
    $configuration: EventConfigurationInput!
  ) {
    eventUpdate(id: $id, input: { configuration: $configuration }) {
      id
    }
  }
`;

export const CustomFieldsSettings = () => {
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const eventId = useParams().eventId!;
  const { loading, data } = useQuery<any>(EVENT_CUSTOM_FIELDS_QUERY, {
    variables: { id: eventId },
    skip: !eventId,
  });
  const [updateEvent] = useMutation<any>(UPDATE_EVENT_CUSTOM_FIELDS);

  if (loading) {
    return (
      <div className="wp-fade-in">
        <PageHeader
          title="Custom Fields"
          showBackButton
          showBreadcrumbs={false}
        />
        <FormSkeleton />
      </div>
    );
  }

  return (
    <div className="wp-fade-in">
      <PageHeader
        title="Custom Fields"
        showBackButton
        showBreadcrumbs={false}
      />
      <CreationForm
        title="Update custom fields"
        schemaDefinition={{
          customFields: constructCustomFieldsForm({
            defaultValue: data?.event?.configuration?.customFields,
            label: "Custom fields",
          }),
        }}
        onSubmit={async (values) => {
          await updateEvent({
            variables: {
              id: eventId,
              configuration: {
                customFields: values.customFields,
              },
            },
          }).then((result) => {
            if (result?.error) {
              throw new Error(result.error.message);
            }
          });
          notifications.show({
            title: "Event updated",
            message: "Custom fields have been updated",
            color: "green",
            autoClose: 3000,
          });
        }}
      />
    </div>
  );
};
